module.exports = __webpack_public_path__ + "static/MarošZeleňák-1bd87b4244137b33f3bedd91cca32c3f.jpg";